import {Box, CircularProgress, Typography} from '@mui/material'
import React from 'react'
import {t} from 'i18next'
import {ReactComponent as PinOutline} from './PinOutline.svg'
import {ReactComponent as PinFilled} from './PinFilled.svg'

interface MapMarkerProps {
  lat: number
  lng: number
  onClick?: () => void
  isLoading?: boolean
  title?: string
  loadingText?: string
  outLine?: boolean
}

export const MapMarker: React.FC<MapMarkerProps> = ({
  onClick,
  isLoading = false,
  title,
  loadingText,
  outLine = false
}) => {
  return (
    <div onClick={onClick} style={styles.container(!!onClick)}>
      <div style={styles.pinWrapper(outLine)}>{outLine ? <PinOutline /> : <PinFilled />}</div>
      <Box sx={styles.contentBox}>
        {isLoading && (
          <>
            <CircularProgress size={20} sx={styles.loadingSpinner} />
            <Typography variant="body2" sx={styles.loadingText}>
              {loadingText ?? t('orderIntake.rmc.jobSiteModal.create.loadingAddress')}
            </Typography>
          </>
        )}
        {!isLoading && title && (
          <Typography variant="body2" sx={styles.locationText}>
            {title}
          </Typography>
        )}
      </Box>
    </div>
  )
}

const styles = {
  container: (hasClick: boolean) => ({
    cursor: hasClick ? 'pointer' : 'default',
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center' as const,
    position: 'relative' as const,
    background: '#FF0000'
  }),
  pinWrapper: (isOutline: boolean) => ({
    zIndex: isOutline ? 888 : 999
  }),
  contentBox: {
    display: 'flex',
    flexDirection: 'row' as const,
    alignItems: 'center' as const,
    gap: 0.5,
    padding: '0px 12px 8px 12px',
    borderRadius: 1,
    minWidth: '120px'
  },
  loadingSpinner: {
    color: '#016AD4',
    mb: 0.5
  },
  loadingText: {
    fontWeight: 500,
    fontSize: '12px',
    color: '#016AD4',
    textAlign: 'center' as const,
    whiteSpace: 'nowrap' as const
  },
  locationText: {
    width: '200px',
    color: '#29333D',
    textAlign: 'center' as const,
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal' as const,
    fontWeight: 500,
    lineHeight: '20px',
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    padding: '4px 8px',
    borderRadius: '4px',
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
    maxWidth: '250px',
    wordWrap: 'break-word' as const,
    textTransform: 'none' as const,
    zIndex: 999
  }
}
